import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  adminAuthMiddleware,
  adminAuthReducer,
  adminAuthReducerPath,
  adminMiddleware,
  adminReducer,
  adminReducerPath,
  adminSliceReducer,
} from "./api/admin";

import {
  usersApiMiddleWare,
  usersApiReducer,
  usersApiReducerPath,
} from "./api/users";

import {
  lendersApiMiddleWare,
  lendersApiReducer,
  lendersApiReducerPath,
} from "./api/lenders";

import {
  contentApiReducer,
  contentApiReducerMiddleware,
  contentApiReducerPath,
} from "./api/static_content";

import {
  queriesApiReducer,
  queriesApiReducerMiddleware,
  queriesApiReducerPath,
} from "./api/queries/api";

import {
  jobsApiMiddleWare,
  jobsApiReducer,
  jobsApiReducerPath,
} from "./api/jobs";

import {
  chatsApiReducer,
  chatsApiMiddleware,
  chatsApiReducerPath,
} from "./api/chats";


 import {propertyApiReducer,propertyApiMiddleWare,propertyApiReducerPath}  from './api/property_preference'
import {
  designationApiMiddleWare,
  designationApiReducer,
  designationApiReducerPath,
} from "./api/designation";

import {
  applicantApiMiddleWare,
  applicantApiReducer,
  applicantApiReducerPath,
} from "./api/applicant";

import {
  transactionsApiMiddleWare,
  transactionsApiReducer,
  transactionsApiReducerPath,
} from "./api/transactions";
import { accountApiMiddleWare, accountApiReducer, accountApiReducerPath } from "./api/public";

export const store = configureStore({
  reducer: {
    [adminAuthReducerPath]: adminAuthReducer,
    [adminReducerPath]: adminReducer,
    adminSlice: adminSliceReducer,

    [usersApiReducerPath]: usersApiReducer,
    [lendersApiReducerPath]: lendersApiReducer,
    [jobsApiReducerPath]: jobsApiReducer,
    [contentApiReducerPath]: contentApiReducer,
    [queriesApiReducerPath]: queriesApiReducer,
    [chatsApiReducerPath]: chatsApiReducer,
    [designationApiReducerPath]: designationApiReducer,
    [applicantApiReducerPath]: applicantApiReducer,
    [transactionsApiReducerPath]: transactionsApiReducer,
    [accountApiReducerPath]: accountApiReducer,
    [propertyApiReducerPath] :propertyApiReducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(adminAuthMiddleware)
      .concat(adminMiddleware)
      .concat(usersApiMiddleWare)
      .concat(lendersApiMiddleWare)
      .concat(jobsApiMiddleWare)
      .concat(contentApiReducerMiddleware)
      .concat(queriesApiReducerMiddleware)
      .concat(chatsApiMiddleware)
      .concat(designationApiMiddleWare)
      .concat(applicantApiMiddleWare)
      .concat(transactionsApiMiddleWare)
      .concat(accountApiMiddleWare)
      .concat(propertyApiMiddleWare)
  },
});
setupListeners(store.dispatch);

//admin
export {
  useLoginMutation,
  logoutUser,
  setAuth,
  clearAuth,
  useGetSummaryQuery,
  useGetProfileQuery,
  useUpdateProfileMutation,
} from "./api/admin";

// Users
export {
  useGetAllUsersQuery,
  useGetSingleUserQuery,
  useDeleteUserMutation,
  useToggleActivationMutation,
} from "./api/users";

// Lenders
export {
  useGetAllLendersQuery,
  useGetSingleLenderQuery,
  useToggleLenderActivationMutation,
  useDeleteLenderMutation,
} from "./api/lenders";

//Jobs
export {
  useGetAllJobsQuery,
  useGetSingleJobQuery,
  useAssignJobMutation,
  useUpdateJobMutation,
  useDeleteJobMutation
} from "./api/jobs";

// static content
export {
  useCreateContentMutation,
  useDeleteContentMutation,
  useGetContentQuery,
} from "./api/static_content";

// queries
export {
  useGetAllQueriesQuery,
  useRespondQueryMutation,
  useDeleteQueryMutation,
  useSubmitQueryMutation,
} from "./api/queries";

// chats
export {
  useGetAllMessagesQuery,
  useSendMessageMutation,
  useApproveMsgMutation,
  useGetImagesQuery,
  chatsApiMiddleware,
} from "./api/chats";


// property 
 export {
  useGetAllpropertyQuery,
  useGetSinglepropertyQuery,
  useUpdatePropertyMutation
 }  from './api/property_preference'
// designation
export {
  useAddDesignationMutation,
  useDeleteDesignationMutation,
  useEditDesignationMutation,
  useGetAllDesignationQuery,
  useGetSingleDesignationQuery
} from "./api/designation"

// applicant
export {
  useGetAllApplicantQuery,
  useGetSingleApplicantQuery,
  useDeleteApplicantMutation,
  useAddApplicantMutation,
  useEditApplicantMutation
} from "./api/applicant"

// transactions
export {
  useGetAllTransactionsQuery,
  useGetSingleTransactionQuery
} from "./api/transactions"

// public
export {
  useDeleteAccountMutation
} from "./api/public"